import script from "./ChatLayoutSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatLayoutSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ChatLayoutSkeleton.vue?vue&type=style&index=0&id=747bfe45&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-747bfe45"]])

export default __exports__